import { render, staticRenderFns } from "./khal.vue?vue&type=template&id=8188e532&scoped=true&"
import script from "./khal.vue?vue&type=script&lang=js&"
export * from "./khal.vue?vue&type=script&lang=js&"
import style0 from "./khal.vue?vue&type=style&index=0&id=8188e532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8188e532",
  null
  
)

export default component.exports